import { constants } from '@bedc/constants';

import { Request } from '../../../../api/admin/user/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const UserAdminType = SearchDataTableType({
	request: Request,
	columnFields: constants.user.search.adminColumnFields,
	filterIds: [
		...constants.user.search.adminFilterFields,
		...constants.user.search.adminFilterBooleanFields,
	],
});
